import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'

const credentialTypes = ['partner-identifier-code'] as const
const locationCredentialTypes = [] as const

export type rocoCredType =
  | (typeof credentialTypes)[number]
  | (typeof locationCredentialTypes)[number]

export const rocoDocumentTypes = [
  'invoice',
  'proof-of-delivery',
] as const satisfies readonly DocumentType[]

export const roco: CarrierDef<rocoCredType> = {
  name: 'RXO',
  scac: 'roco',
  ltlServices: [
    { id: 'standard', name: 'Standard' },
    {
      id: 'guaranteed_five_pm',
      name: 'Guaranteed 5PM',
      guaranteed: true,
      guaranteedByTime: '17:00',
    },
    {
      id: 'guaranteed_twelve_pm',
      name: 'Guaranteed Noon',
      guaranteed: true,
      guaranteedByTime: '12:00',
    },
    { id: 'freight_economy', name: 'FedEx Freight® Economy' },
    {
      id: 'freight_economy_am_delivery',
      name: 'FedEx Freight® Economy (A.M. Delivery)',
      guaranteed: true,
      guaranteedByTime: '10:00',
    },
    {
      id: 'freight_economy_close_of_business',
      name: 'FedEx Freight® Economy (Close of Business Delivery)',
      guaranteed: true,
      guaranteedByTime: '17:00',
    },
    { id: 'freight_priority', name: 'FedEx Freight® Priority' },
    {
      id: 'freight_priority_am_delivery',
      name: 'FedEx Freight® Priority (A.M. Delivery)',
      guaranteed: true,
      guaranteedByTime: '10:00',
    },
    {
      id: 'freight_priority_close_of_business',
      name: 'FedEx Freight® Priority (Close of Business Delivery)',
      guaranteed: true,
      guaranteedByTime: '17:00',
    },
  ],
  credentialTypes,
  locationCredentialTypes,
  legacyCredMap: [],
  credentialConfig: {
    'partner-identifier-code': { customerIdentifier: true },
  },
  engineLayers: ['rating', 'bol', 'pickup', 'documents', 'invoice', 'tracking'],
  documentTypes: rocoDocumentTypes,
}
